export const ContainerType = {
  DRUM_220: 'DRUM_220',
  IBC_1000: 'IBC_1000',
  WELL_10: 'WELL_10',
} as const;

export type TContainerType = (typeof ContainerType)[keyof typeof ContainerType];

export function getMaxCapacityCm(containerType: TContainerType) {
  switch (containerType) {
    case 'DRUM_220':
      return 92; // Height in CM
    case 'IBC_1000':
      return 100; // Height in CM (1m)
    case 'WELL_10':
      return 1000; // Depth in CM (10m)
    default:
      return 0;
  }
}

export function getMaxCapacityLiters(containerType: TContainerType) {
  switch (containerType) {
    case 'DRUM_220':
      return 220; // Liters
    case 'IBC_1000':
      return 1000; // Liters
    case 'WELL_10':
      return 10000; // Liters (10m³)
    default:
      return 0;
  }
}
